import React, { useState } from "react"
import axios from "axios"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import "./styles/Contact.css"

const Contact = () => {
  const [leadInfo, setLeadInfo] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    zipCode: "",
    message: "",
    service: "",
    preferredAppointmentDateTime: new Date(),
  })

  const handleChange = (e) => {
    setLeadInfo({ ...leadInfo, [e.target.name]: e.target.value })
  }

  const [selectedDate, setSelectedDate] = useState(null)
  const handleDateChange = (date) => {
    setSelectedDate(date)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      const token = window.localStorage.getItem("token")
      await axios.post("/api/lead", leadInfo, {
        headers: {
          authorization: token,
        },
      })
      alert("Thank you for contacting us, we will get back to you shortly.")
      setLeadInfo({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        address: "",
        city: "",
        zipCode: "",
        message: "",
        service: "",
        preferredAppointmentDateTime: new Date(),
      })
    } catch (error) {
      console.error("Failed to submit lead info", error)
      alert("There was an error submitting your request.")
    }
  }

  return (
    <div className="contact-form-container">
      <h1>Get Your Free Quote Today!</h1>
      <h1> Call, Text or Email Below</h1>
      <div className="contact-form">
        <div className="quote-form">
          <h2>Fill Out The Form To Get A Free Estimate</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                name="firstName"
                value={leadInfo.firstName}
                onChange={handleChange}
                placeholder="First Name"
                required
              />
              <input
                type="text"
                name="lastName"
                value={leadInfo.lastName}
                onChange={handleChange}
                placeholder="Last Name"
                required
              />
            </div>
            <div className="form-group">
              <input
                type="email"
                name="email"
                value={leadInfo.email}
                onChange={handleChange}
                placeholder="Your Email"
                required
              />
              <input
                type="text"
                name="phone"
                value={leadInfo.phone}
                onChange={handleChange}
                placeholder="Phone Number"
                required
              />
            </div>
            <input
              type="text"
              name="address"
              value={leadInfo.address}
              onChange={handleChange}
              placeholder="Your Address"
            />
            <div className="form-group">
              <input
                type="text"
                name="city"
                value={leadInfo.city}
                onChange={handleChange}
                placeholder="Your City"
                required
              />
              <input
                type="text"
                name="zipCode"
                value={leadInfo.zipCode}
                onChange={handleChange}
                placeholder="Zip Code"
                required
              />
            </div>
            <textarea
              name="message"
              value={leadInfo.message}
              onChange={handleChange}
              placeholder="Your Message"
            />
            <select
              className="service-select"
              name="service"
              value={leadInfo.service}
              onChange={handleChange}
              required
            >
              <option value="">---Select Type of Service---</option>
              <option value="Gutter Cleaning">Gutter Cleaning</option>
              <option value="Gutter Repairs">Gutter Repairs</option>
              <option value="Gutter Installation">Gutter Installation</option>
              <option value="Gutter Guards Installation">Gutter Guards</option>
              <option value="Gutter Replacement">Gutter Replacement</option>
              <option value="Leak Detection & Repairs">
                Leak Detection & Repairs
              </option>
              <option value="Roof Cleaning">Roof Cleaning</option>
            </select>
            <DatePicker
              selected={selectedDate}
              onChange={handleDateChange}
              placeholderText="---Preferred Appointment Date & Time---"
              showTimeSelect
              timeFormat="h:mm aa"
              timeIntervals={15}
              timeCaption="Time"
              dateFormat="MMMM d, yyyy h:mm aa"
            />
            <button type="submit">Submit Form</button>
          </form>
        </div>
        <div className="privacy-policy">
          <h2>Privacy Policy</h2>
          <p>
            Manny's Seamless Gutters, Inc. commits to safeguarding your personal
            data. When you request services such as a callback or a service
            call, we will utilize your information only to meet your request. We
            ensure the confidentiality of your personal details and do not
            disseminate or sell them to any external entities. We adopt all
            necessary precautions to prevent unauthorized access or misuse of
            your data.
          </p>
          <p>
            The data you share with us will be used exclusively for delivering
            the requested service.
          </p>
        </div>
      </div>
    </div>
  )
}

export default Contact
